import { useState } from 'react'
import { PaginationPayload, useDataProvider } from 'react-admin'

export type Product = {
  id: string
  name: string
  total_items_count: number
}

const DEFAULT_PAGE = 1
const DEFAULT_TOTAL_PAGES = 1
const DEFAULT_PER_PAGE = 10

export const useDigitalOrders = () => {
  const dataProvider = useDataProvider()
  const [hasDigitalOrders, setHasDigitalOrders] = useState(false)
  const [products, setProducts] = useState<Product[]>([])
  const [hasBatches, setHasBatches] = useState(false)
  const [totalPages, setTotalPages] = useState(DEFAULT_TOTAL_PAGES)
  const [pagination, setPagination] = useState<PaginationPayload>({
    page: DEFAULT_PAGE,
    perPage: DEFAULT_PER_PAGE
  })

  const setPage = (page: number) => setPagination({ ...pagination, page })

  const fetchDigitalProducts = async () => {
    const { data, total, meta } = await dataProvider.getList('digital-orders', {
      pagination
    })

    if (total) {
      setHasDigitalOrders(true)
    }

    const totalPages = Math.ceil((total || 1) / pagination.perPage)

    setProducts(data)
    setTotalPages(totalPages)
    setHasBatches(meta)
  }

  return {
    hasDigitalOrders,
    hasBatches,
    products,
    totalPages,
    pagination,
    setPage,
    fetchDigitalProducts
  }
}
